import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuthUser } from '../../context/AuthUserContext';
import './Auth.css';

const IconUser     = () => (<svg viewBox="0 0 24 24" fill="none" width="17" height="17"><path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><circle cx="12" cy="7" r="4" stroke="currentColor" strokeWidth="2"/></svg>);
const IconMail     = () => (<svg viewBox="0 0 24 24" fill="none" width="17" height="17"><path d="M4 4h16c1.1 0 2 .9 2 2v12a2 2 0 01-2 2H4a2 2 0 01-2-2V6c0-1.1.9-2 2-2z" stroke="currentColor" strokeWidth="2"/><polyline points="22,6 12,13 2,6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconPhone    = () => (<svg viewBox="0 0 24 24" fill="none" width="17" height="17"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.81a19.79 19.79 0 01-3.07-8.67A2 2 0 012 1h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.91 8.41a16 16 0 006.29 6.29l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconLock     = () => (<svg viewBox="0 0 24 24" fill="none" width="17" height="17"><rect x="3" y="11" width="18" height="11" rx="2" stroke="currentColor" strokeWidth="2"/><path d="M7 11V7a5 5 0 0110 0v4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconEye      = () => (<svg viewBox="0 0 24 24" fill="none" width="16" height="16"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" stroke="currentColor" strokeWidth="2"/><circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="2"/></svg>);
const IconEyeOff   = () => (<svg viewBox="0 0 24 24" fill="none" width="16" height="16"><path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19m-6.72-1.07a3 3 0 11-4.24-4.24" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><line x1="1" y1="1" x2="23" y2="23" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconCheck    = () => (<svg viewBox="0 0 20 20" fill="none" width="15" height="15"><circle cx="10" cy="10" r="9" fill="rgba(130,216,179,.2)"/><path d="M6 10l3 3 5-5" stroke="#4db88a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconArrow    = () => (<svg viewBox="0 0 20 20" fill="none" width="16" height="16"><path d="M4 10h12M11 6l5 4-5 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconSpinner  = () => (<svg viewBox="0 0 24 24" fill="none" width="18" height="18" style={{animation:'spin .7s linear infinite'}}><circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" strokeOpacity=".25"/><path d="M12 2a10 10 0 0110 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconWhatsapp = () => (<svg viewBox="0 0 24 24" fill="none" width="17" height="17"><path d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>);

const PERFILES = [
  { val:'terapeuta', label:'Terapeuta' },
  { val:'profesor',     label:'Profesor(a)' },
  { val:'familia',  label:'Familia' },
  { val:'afin',        label:'Profesionales afines' },
];

export default function Registro() {
  const { registro } = useAuthUser();
  const navigate     = useNavigate();
  const location     = useLocation();
  const params       = new URLSearchParams(location.search);
  const from         = params.get('redirect') || location.state?.from || '/mi-cuenta';

  const [form, setForm] = useState({
    nombre:'', apellido:'', email:'', telefono:'',
    whatsapp:'', password:'', confirmar:'',
    perfil:'profesional', acepta_whatsapp: false,
  });
  const [verPass,   setVerPass]   = useState(false);
  const [errores,   setErrores]   = useState({});
  const [cargando,  setCargando]  = useState(false);
  const [exitoso,   setExitoso]   = useState(false);

  const setF = (k,v) => { setForm(f=>({...f,[k]:v})); if(errores[k]) setErrores(e=>({...e,[k]:''})); };

  const validar = () => {
    const e = {};
    if (!form.nombre.trim())                          e.nombre    = 'Ingresa tu nombre';
    if (!form.email || !/\S+@\S+\.\S+/.test(form.email)) e.email = 'Email no válido';
    if (form.password.length < 6)                     e.password  = 'Mínimo 6 caracteres';
    if (form.password !== form.confirmar)             e.confirmar = 'Las contraseñas no coinciden';
    setErrores(e);
    return Object.keys(e).length === 0;
  };

  const handleSubmit = async e => {
    e.preventDefault();
    if (!validar()) return;
    setCargando(true);
    try {
      await registro({
        nombre:          form.nombre.trim(),
        apellido:        form.apellido.trim(),
        email:           form.email.toLowerCase().trim(),
        telefono:        form.telefono.trim(),
        whatsapp:        form.whatsapp.trim() || form.telefono.trim(),
        password:        form.password,
        perfil:          form.perfil,
        acepta_whatsapp: form.acepta_whatsapp,
      });
      setExitoso(true);
      setTimeout(() => navigate(from, { replace: true }), 1800);
    } catch(err) {
      setErrores({ general: err.message || 'Error al crear la cuenta' });
    } finally {
      setCargando(false);
    }
  };

  if (exitoso) return (
    <div className="auth-page">
      <div className="auth-bg"><div className="auth-blob auth-blob--a"/><div className="auth-blob auth-blob--b"/></div>
      <div className="auth-container">
        <div className="auth-card auth-card--exito">
          <div className="auth-exito__icon">
            <svg viewBox="0 0 24 24" fill="none" width="44" height="44">
              <circle cx="12" cy="12" r="10" fill="#d4f4e8"/>
              <path d="M8 12l3 3 5-5" stroke="#4db88a" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
          <h2>¡Cuenta creada!</h2>
          <p>{from === '/carrito' ? 'Volviendo a tu carrito…' : 'Redirigiendo a tu perfil…'}</p>
        </div>
      </div>
    </div>
  );

  return (
    <div className="auth-page">
      <div className="auth-bg">
        <div className="auth-blob auth-blob--a"/>
        <div className="auth-blob auth-blob--b"/>
        <div className="auth-grid" aria-hidden="true"/>
      </div>

      <div className="auth-container auth-container--wide">
      <Link to="/" className="auth-logo">
          <img src="/images/logo_centro.png" alt="Comunicar" style={{height:52,width:'auto',display:'block'}}/>
        </Link>

        <div className="auth-card">
          <div className="auth-card__head">
            <h1>Crear cuenta</h1>
            <p>Accede a tu historial, puntos y formaciones en un solo lugar.</p>
          </div>

          {/* Beneficios */}
          <div className="auth-beneficios">
            {['Ver tus descargas y recursos comprados','Consultar tus puntos y nivel','Tus formaciones en el Aula Virtual','Contacto directo por WhatsApp'].map(b=>(
              <span key={b} className="auth-ben"><IconCheck/>{b}</span>
            ))}
          </div>

          {errores.general && <div className="auth-error">{errores.general}</div>}

          <form className="auth-form" onSubmit={handleSubmit} noValidate>

            <div className="auth-form__grid">
              {/* Nombre */}
              <div className={`auth-field ${errores.nombre?'auth-field--error':''}`}>
                <label>Nombre <span className="auth-req">*</span></label>
                <div className="auth-field__wrap">
                  <span className="auth-field__icon"><IconUser/></span>
                  <input type="text" placeholder="Ej: Ana" value={form.nombre}
                    onChange={e=>setF('nombre',e.target.value)} autoComplete="given-name"/>
                </div>
                {errores.nombre && <span className="auth-field__err">{errores.nombre}</span>}
              </div>

              {/* Apellido */}
              <div className="auth-field">
                <label>Apellido</label>
                <div className="auth-field__wrap">
                  <span className="auth-field__icon"><IconUser/></span>
                  <input type="text" placeholder="Ej: García" value={form.apellido}
                    onChange={e=>setF('apellido',e.target.value)} autoComplete="family-name"/>
                </div>
              </div>

              {/* Email */}
              <div className={`auth-field auth-field--full ${errores.email?'auth-field--error':''}`}>
                <label>Correo electrónico <span className="auth-req">*</span></label>
                <div className="auth-field__wrap">
                  <span className="auth-field__icon"><IconMail/></span>
                  <input type="email" placeholder="tu@correo.com" value={form.email}
                    onChange={e=>setF('email',e.target.value)} autoComplete="email"/>
                </div>
                {errores.email && <span className="auth-field__err">{errores.email}</span>}
              </div>

             {/* Teléfono */}
             <div className="auth-field auth-field--full">
                <label>Teléfono</label>
                <div className="auth-field__wrap">
                  <span className="auth-field__icon"><IconPhone/></span>
                  <input type="tel" placeholder="+51 999 000 111" value={form.telefono}
                    onChange={e=>setF('telefono',e.target.value)} autoComplete="tel"/>
                </div>
              </div>

              {/* Perfil */}
              <div className="auth-field auth-field--full">
                <label>Soy</label>
                <div className="auth-perfil-tabs">
                  {PERFILES.map(({val,label})=>(
                    <button key={val} type="button"
                      className={`auth-perfil-tab ${form.perfil===val?'auth-perfil-tab--active':''}`}
                      onClick={()=>setF('perfil',val)}
                    >
                      {label}
                    </button>
                  ))}
                </div>
              </div>

              {/* Contraseña */}
              <div className={`auth-field ${errores.password?'auth-field--error':''}`}>
                <label>Contraseña <span className="auth-req">*</span></label>
                <div className="auth-field__wrap">
                  <span className="auth-field__icon"><IconLock/></span>
                  <input type={verPass?'text':'password'} placeholder="Mínimo 6 caracteres"
                    value={form.password} onChange={e=>setF('password',e.target.value)} autoComplete="new-password"/>
                  <button type="button" className="auth-field__toggle" onClick={()=>setVerPass(v=>!v)}>
                    {verPass?<IconEyeOff/>:<IconEye/>}
                  </button>
                </div>
                {errores.password && <span className="auth-field__err">{errores.password}</span>}
              </div>

              {/* Confirmar */}
              <div className={`auth-field ${errores.confirmar?'auth-field--error':''}`}>
                <label>Confirmar contraseña <span className="auth-req">*</span></label>
                <div className="auth-field__wrap">
                  <span className="auth-field__icon"><IconLock/></span>
                  <input type={verPass?'text':'password'} placeholder="Repite tu contraseña"
                    value={form.confirmar} onChange={e=>setF('confirmar',e.target.value)} autoComplete="new-password"/>
                </div>
                {errores.confirmar && <span className="auth-field__err">{errores.confirmar}</span>}
              </div>
            </div>

            {/* WhatsApp opt-in */}
            <label className="auth-checkbox">
              <input type="checkbox" checked={form.acepta_whatsapp}
                onChange={e=>setF('acepta_whatsapp',e.target.checked)}/>
              <span>Acepto recibir novedades y recursos por WhatsApp</span>
            </label>

            <button type="submit" className="auth-submit" disabled={cargando}>
              {cargando ? <><IconSpinner/> Creando cuenta…</> : <>Crear mi cuenta <IconArrow/></>}
            </button>

            <p className="auth-legal">
              Al completar tu registro, aceptas recibir información sobre recursos educativos, eventos, cursos y otros contenidos relacionados con las actividades de Comunicar.
            </p>

          </form>

          <div className="auth-footer">
            <p>¿Ya tienes cuenta? <Link to="/login">Iniciar sesión</Link></p>
          </div>
        </div>
      </div>
    </div>
  );
}